module.exports = __webpack_public_path__ + "static/media/map-marker-divisions.d4144271.svg";